import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { FaReact, FaNodeJs, FaFigma } from 'react-icons/fa';
import {
  SiJavascript, SiRedux, SiRuby, SiJest,
} from 'react-icons/si';
import { TbBrandMongodb } from 'react-icons/tb';
import { BsFiletypeSql } from 'react-icons/bs';
import { BiLogoPostgresql } from 'react-icons/bi';
import { useTranslation } from 'react-i18next';

export const Skills = () => {
  const [t] = useTranslation('global');
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="skill" id="skills">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="skill-bx wow zoomIn">
              <h2>{t('skills.title')}</h2>
              <p className="text-white">
                {t('skills.description')}
                <br />
              </p>
              <Carousel
                responsive={responsive}
                infinite
                className="owl-carousel owl-theme skill-slider"
              >
                <div className="item">  
                  <div className="center-text">
                    <FaReact className="react-icon" />
                  </div>
                  <div className="column-container">
                    <h5 className="center-text">React</h5>
                  </div>
                </div>

                <div className="item">
                  
                  <div className="center-text">
                    <SiJavascript className="javascript-icon" />
                  </div>
                  <div className="column-container">
                    <h5 className="center-text">Javascript</h5>
                  </div>
                </div>

                <div className="item">
                  
                  <div className="center-text">
                    <FaNodeJs className="node-icon" />
                  </div>
                  <div className="column-container">
                    <h5 className="center-text">Node.js</h5>
                  </div>
                </div>

                <div className="item">
                  
                  <div className="center-text">
                    <SiRedux className="redux-icon" />
                  </div>
                  <div className="column-container">
                    <h5 className="center-text">Redux</h5>
                  </div>
                </div>

                <div className="item">
                  
                  <div className="center-text">
                    <BsFiletypeSql className="sql-icon" />
                  </div>
                  <div className="column-container">
                    <h5 className="center-text">SQL</h5>
                  </div>
                </div>

                <div className="item">
                  
                  <div className="center-text">
                    <BiLogoPostgresql className="postgre-icon" />
                  </div>
                  <div className="column-container">
                    <h5 className="center-text">PostgreSQL</h5>
                  </div>
                </div>

                <div className="item">
                  
                  <div className="center-text">
                    <TbBrandMongodb className="postgre-icon" />
                  </div>
                  <div className="column-container">
                    <h5 className="center-text">MongoDB</h5>
                  </div>
                </div>

                <div className="item">
                  
                  <div className="center-text">
                    <SiRuby className="ruby-icon" />
                  </div>
                  <div className="column-container">
                    <h5 className="center-text">Ruby</h5>
                  </div>
                </div>

                <div className="item">
                  
                  <div className="center-text">
                    <FaFigma className="figma-icon" />
                  </div>
                  <div className="column-container">
                    <h5 className="center-text">Figma</h5>
                  </div>
                </div>

                <div className="item">
                  
                  <div className="center-text">
                    <SiJest className="jest-icon" />
                  </div>
                  <div className="column-container">
                    <h5 className="center-text">Jest</h5>
                  </div>
                </div>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
